import { Component, OnInit, inject } from '@angular/core';
import { TimelineComponent } from '../../components/timeline/timeline.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { ProcessService } from '../../services/process.service';
import { ProcessDetails } from '../../models/process-details.model';
import { ActivatedRoute } from '@angular/router';
import { ProcessStep } from '../../models/process-step.model';
import { Status } from '../../shared/enums/status';

@Component({
  selector: 'hub-process-details',
  standalone: true,
  imports: [TimelineComponent, TitleComponent],
  template: `
    <hub-title text="Detalhes do processo" />
    <hub-timeline
      [processId]="processId"
      [processName]="processName"
      [processCreatedDate]="processCreatedDate"
      [steps]="processSteps" />
  `,
  styleUrl: './process-details.component.scss',
})
export class ProcessDetailsComponent implements OnInit {
  private processService = inject(ProcessService);
  private route = inject(ActivatedRoute);
  public processId!: string;
  public processName!: string;
  public processCreatedDate!: string;
  public processDetails!: ProcessDetails;
  public processSteps!: Array<ProcessStep>;
  ngOnInit(): void {
    this.processId = String(this.route.snapshot.paramMap.get('id'));

    this.getProcessDetails(this.processId);
  }

  private getProcessDetails(processId: string) {
    this.processService.getProcessById(processId).subscribe({
      next: response => {
        this.processId = response.id;
        this.processName = response.name;
        this.processCreatedDate = response.createdAt;
        this.processSteps = response.steps
          .map((step: ProcessStep) => {
            step.statusDescription = Status[step.status];

            return step;
          })
          .filter((step: any) => step.status != Status.Pendente);
      },
    });
  }
}
